import { useGetMenuCategories } from "./use-get-menu-categories";

type Props = {
	menuData: ReturnType<typeof useGetMenuCategories>["categories"];
};

export function MenuPreview({ menuData }: Props) {
	return (
		<div className="col-6">
			<p>Previsualización</p>
			{menuData.map(
				(category) =>
					category.showInMenu && (
						<div key={category.id}>
							<h2>{category.name}</h2>
							<ul>
								{category.items.map((item) => {
									if (item.showInMenu === false) return null;

									if ("showAs" in item) {
										// It's a group
										if (item.showAs === "none") {
											return (
												<li
													key={item.id}
													className="d-flex justify-content-between"
												>
													<span>{item.name}</span>
													<span>{item.items[0].product.price}</span>
												</li>
											);
										}

										if (item.showAs === "inline") {
											if (item.items.every((i) => !i.showInMenu)) return null;

											return (
												<li
													key={item.id}
													className="d-flex justify-content-between"
												>
													<span>
														{item.items
															.filter((i) => i.showInMenu)
															.map((i) => i.product.displayName)
															.join(", ")}
													</span>
													<span>
														{item.items[0] && item.items[0].product.price}
													</span>
												</li>
											);
										}

										return (
											<li key={item.id} className="d-flex flex-column">
												<span>{item.name}</span>
												<ul>
													{item.items.map(
														(groupItem) =>
															groupItem.showInMenu && (
																<li
																	key={groupItem.id}
																	className="d-flex justify-content-between"
																>
																	<span>{groupItem.product.displayName}</span>
																	<span>{groupItem.product.price}</span>
																</li>
															),
													)}
												</ul>
											</li>
										);
									}
									// It's a single item
									return (
										item.showInMenu && (
											<li
												key={item.id}
												className="d-flex justify-content-between"
											>
												<span>{item.product.displayName}</span>
												<span>{item.product.price}</span>
											</li>
										)
									);
								})}
							</ul>
						</div>
					),
			)}
		</div>
	);
}
